import * as React from "react";
const headerTemplate = (props) => {
  return (
      
        <div
            className="row"
            style={{
              position: "relative",
              left: "13px",
              width: "100%",
              backgroundColor:"rgb(38 42 43)",
              padding:"20px",
              zIndex: "2"
            }}
          >
          <div className="logoimage" style={{ margin: "0 auto", opacity:"2" }} >
              <img src={require('Assets/img/tsga-logo.png')} className="img-fluid" alt="site-logo" width="200" height="20" />
          </div>
          
        </div>
        
  );
};
export default headerTemplate;